module.exports = __webpack_public_path__ + "static/img/border1.1dbba88e.png";